import { render, staticRenderFns } from "./DeliveryZones.vue?vue&type=template&id=1169b1a5&"
import script from "./DeliveryZones.vue?vue&type=script&lang=js&"
export * from "./DeliveryZones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports